export const countryToIsoCode: { [key: string]: string } = {
    "afghanistan": "AF",
    "albania": "AL",
    "algeria": "DZ",
    "andorra": "AD",
    "angola": "AO",
    "antigua and barbuda": "AG",
    "argentina": "AR",
    "armenia": "AM",
    "australia": "AU",
    "austria": "AT",
    "azerbaijan": "AZ",
    "bahamas": "BS",
    "bahrain": "BH",
    "bangladesh": "BD",
    "barbados": "BB",
    "belarus": "BY",
    "belgium": "BE",
    "belize": "BZ",
    "benin": "BJ",
    "bhutan": "BT",
    "bolivia": "BO",
    "bosnia and herzegovina": "BA",
    "botswana": "BW",
    "brazil": "BR",
    "brunei": "BN",
    "bulgaria": "BG",
    "burkina faso": "BF",
    "burundi": "BI",
    "cambodia": "KH",
    "cameroon": "CM",
    "canada": "CA",
    "cape verde": "CV",
    "central african republic": "CF",
    "chad": "TD",
    "chile": "CL",
    "china": "CN",
    "colombia": "CO",
    "comoros": "KM",
    "congo": "CG",
    "democratic republic of the congo": "CD",
    "costa rica": "CR",
    "croatia": "HR",
    "cuba": "CU",
    "cyprus": "CY",
    "czech republic": "CZ",
    "denmark": "DK",
    "djibouti": "DJ",
    "dominica": "DM",
    "dominican republic": "DO",
    "ecuador": "EC",
    "egypt": "EG",
    "el salvador": "SV",
    "equatorial guinea": "GQ",
    "eritrea": "ER",
    "estonia": "EE",
    "ethiopia": "ET",
    "fiji": "FJ",
    "finland": "FI",
    "france": "FR",
    "gabon": "GA",
    "gambia": "GM",
    "georgia": "GE",
    "germany": "DE",
    "ghana": "GH",
    "greece": "GR",
    "grenada": "GD",
    "guatemala": "GT",
    "guinea": "GN",
    "guinea-bissau": "GW",
    "guyana": "GY",
    "haiti": "HT",
    "honduras": "HN",
    "hungary": "HU",
    "iceland": "IS",
    "india": "IN",
    "indonesia": "ID",
    "iran": "IR",
    "iraq": "IQ",
    "ireland": "IE",
    "israel": "IL",
    "italy": "IT",
    "ivory coast": "CI",
    "jamaica": "JM",
    "japan": "JP",
    "jordan": "JO",
    "kazakhstan": "KZ",
    "kenya": "KE",
    "kiribati": "KI",
    "north korea": "KP",
    "south korea": "KR",
    "kosovo": "XK",
    "kuwait": "KW",
    "kyrgyzstan": "KG",
    "laos": "LA",
    "latvia": "LV",
    "lebanon": "LB",
    "lesotho": "LS",
    "liberia": "LR",
    "libya": "LY",
    "liechtenstein": "LI",
    "lithuania": "LT",
    "luxembourg": "LU",
    "macedonia": "MK",
    "madagascar": "MG",
    "malawi": "MW",
    "malaysia": "MY",
    "maldives": "MV",
    "mali": "ML",
    "malta": "MT",
    "marshall islands": "MH",
    "mauritania": "MR",
    "mauritius": "MU",
    "mexico": "MX",
    "micronesia": "FM",
    "moldova": "MD",
    "monaco": "MC",
    "mongolia": "MN",
    "montenegro": "ME",
    "morocco": "MA",
    "mozambique": "MZ",
    "myanmar": "MM",
    "namibia": "NA",
    "nauru": "NR",
    "nepal": "NP",
    "netherlands": "NL",
    "new zealand": "NZ",
    "nicaragua": "NI",
    "niger": "NE",
    "nigeria": "NG",
    "norway": "NO",
    "oman": "OM",
    "pakistan": "PK",
    "palau": "PW",
    "panama": "PA",
    "papua new guinea": "PG",
    "paraguay": "PY",
    "peru": "PE",
    "philippines": "PH",
    "poland": "PL",
    "portugal": "PT",
    "qatar": "QA",
    "romania": "RO",
    "russia": "RU",
    "rwanda": "RW",
    "saint kitts and nevis": "KN",
    "saint lucia": "LC",
    "saint vincent and the grenadines": "VC",
    "samoa": "WS",
    "san marino": "SM",
    "sao tome and principe": "ST",
    "saudi arabia": "SA",
    "senegal": "SN",
    "serbia": "RS",
    "seychelles": "SC",
    "sierra leone": "SL",
    "singapore": "SG",
    "slovakia": "SK",
    "slovenia": "SI",
    "solomon islands": "SB",
    "somalia": "SO",
    "south africa": "ZA",
    "south sudan": "SS",
    "spain": "ES",
    "sri lanka": "LK",
    "sudan": "SD",
    "suriname": "SR",
    "swaziland": "SZ",
    "sweden": "SE",
    "switzerland": "CH",
    "syria": "SY",
    "taiwan": "TW",
    "tajikistan": "TJ",
    "tanzania": "TZ",
    "thailand": "TH",
    "timor-leste": "TL",
    "togo": "TG",
    "tonga": "TO",
    "trinidad and tobago": "TT",
    "tunisia": "TN",
    "turkey": "TR",
    "turkmenistan": "TM",
    "tuvalu": "TV",
    "uganda": "UG",
    "ukraine": "UA",
    "united arab emirates": "AE",
    "united kingdom": "GB",
    "united states": "US",
    "united states of america": "US",
    "uruguay": "UY",
    "uzbekistan": "UZ",
    "vanuatu": "VU",
    "vatican city": "VA",
    "venezuela": "VE",
    "vietnam": "VN",
    "yemen": "YE",
    "zambia": "ZM",
    "zimbabwe": "ZW"
};

export const getCountryCode = (countryName: string): string | undefined => {
    if (!countryName) return undefined;
    return countryToIsoCode[countryName.toLowerCase()];
};

/** ISO 3166-1 alpha-3 → alpha-2 mapping */
const alpha3ToAlpha2: Record<string, string> = {};

// Build reverse lookup from the existing countryToIsoCode map plus explicit alpha-3 codes
const alpha3Entries: [string, string][] = [
    ["AFG","AF"],["ALB","AL"],["DZA","DZ"],["AND","AD"],["AGO","AO"],
    ["ATG","AG"],["ARG","AR"],["ARM","AM"],["AUS","AU"],["AUT","AT"],
    ["AZE","AZ"],["BHS","BS"],["BHR","BH"],["BGD","BD"],["BRB","BB"],
    ["BLR","BY"],["BEL","BE"],["BLZ","BZ"],["BEN","BJ"],["BTN","BT"],
    ["BOL","BO"],["BIH","BA"],["BWA","BW"],["BRA","BR"],["BRN","BN"],
    ["BGR","BG"],["BFA","BF"],["BDI","BI"],["KHM","KH"],["CMR","CM"],
    ["CAN","CA"],["CPV","CV"],["CAF","CF"],["TCD","TD"],["CHL","CL"],
    ["CHN","CN"],["COL","CO"],["COM","KM"],["COG","CG"],["COD","CD"],
    ["CRI","CR"],["HRV","HR"],["CUB","CU"],["CYP","CY"],["CZE","CZ"],
    ["DNK","DK"],["DJI","DJ"],["DMA","DM"],["DOM","DO"],["ECU","EC"],
    ["EGY","EG"],["SLV","SV"],["GNQ","GQ"],["ERI","ER"],["EST","EE"],
    ["ETH","ET"],["FJI","FJ"],["FIN","FI"],["FRA","FR"],["GAB","GA"],
    ["GMB","GM"],["GEO","GE"],["DEU","DE"],["GHA","GH"],["GRC","GR"],
    ["GRD","GD"],["GTM","GT"],["GIN","GN"],["GNB","GW"],["GUY","GY"],
    ["HTI","HT"],["HND","HN"],["HUN","HU"],["ISL","IS"],["IND","IN"],
    ["IDN","ID"],["IRN","IR"],["IRQ","IQ"],["IRL","IE"],["ISR","IL"],
    ["ITA","IT"],["CIV","CI"],["JAM","JM"],["JPN","JP"],["JOR","JO"],
    ["KAZ","KZ"],["KEN","KE"],["KIR","KI"],["PRK","KP"],["KOR","KR"],
    ["XKX","XK"],["KWT","KW"],["KGZ","KG"],["LAO","LA"],["LVA","LV"],
    ["LBN","LB"],["LSO","LS"],["LBR","LR"],["LBY","LY"],["LIE","LI"],
    ["LTU","LT"],["LUX","LU"],["MKD","MK"],["MDG","MG"],["MWI","MW"],
    ["MYS","MY"],["MDV","MV"],["MLI","ML"],["MLT","MT"],["MHL","MH"],
    ["MRT","MR"],["MUS","MU"],["MEX","MX"],["FSM","FM"],["MDA","MD"],
    ["MCO","MC"],["MNG","MN"],["MNE","ME"],["MAR","MA"],["MOZ","MZ"],
    ["MMR","MM"],["NAM","NA"],["NRU","NR"],["NPL","NP"],["NLD","NL"],
    ["NZL","NZ"],["NIC","NI"],["NER","NE"],["NGA","NG"],["NOR","NO"],
    ["OMN","OM"],["PAK","PK"],["PLW","PW"],["PAN","PA"],["PNG","PG"],
    ["PRY","PY"],["PER","PE"],["PHL","PH"],["POL","PL"],["PRT","PT"],
    ["QAT","QA"],["ROU","RO"],["RUS","RU"],["RWA","RW"],["KNA","KN"],
    ["LCA","LC"],["VCT","VC"],["WSM","WS"],["SMR","SM"],["STP","ST"],
    ["SAU","SA"],["SEN","SN"],["SRB","RS"],["SYC","SC"],["SLE","SL"],
    ["SGP","SG"],["SVK","SK"],["SVN","SI"],["SLB","SB"],["SOM","SO"],
    ["ZAF","ZA"],["SSD","SS"],["ESP","ES"],["LKA","LK"],["SDN","SD"],
    ["SUR","SR"],["SWZ","SZ"],["SWE","SE"],["CHE","CH"],["SYR","SY"],
    ["TWN","TW"],["TJK","TJ"],["TZA","TZ"],["THA","TH"],["TLS","TL"],
    ["TGO","TG"],["TON","TO"],["TTO","TT"],["TUN","TN"],["TUR","TR"],
    ["TKM","TM"],["TUV","TV"],["UGA","UG"],["UKR","UA"],["ARE","AE"],
    ["GBR","GB"],["USA","US"],["URY","UY"],["UZB","UZ"],["VUT","VU"],
    ["VAT","VA"],["VEN","VE"],["VNM","VN"],["YEM","YE"],["ZMB","ZM"],
    ["ZWE","ZW"],["PSE","PS"],["HKG","HK"],["MAC","MO"],["SWZ","SZ"],
];

alpha3Entries.forEach(([a3, a2]) => { alpha3ToAlpha2[a3] = a2; });

/**
 * Converts a 3-letter ISO country code to a 2-letter code.
 * Returns the original string if no mapping is found.
 */
export const alpha3ToAlpha2Code = (code: string): string => {
    if (!code) return code;
    return alpha3ToAlpha2[code.toUpperCase()] || code;
};
